import clsx from 'clsx';
import React from 'react';

import LazyImgixImage from '@components/LazyImgixImage';

import ProSecondaryButton from './ProSecondaryButton';
import { ProPerkProps } from './interfaces';

const ProPerk = ({
  buttonText,
  className,
  description,
  isProSubscriberNotBot,
  logoUrl,
  title,
  url,
}: ProPerkProps) => {
  return (
    <div
      className={clsx(
        'flex flex-col sm:flex-row sm:items-center sm:justify-between sm:gap-x-32',
        className
      )}
    >
      <div className="w-full sm:max-w-[345px] md:max-w-[465px]">
        <h3 className="m-0 font-suisse-works text-headline-xxs text-primary-black">{title}</h3>
        <p className="m-0 mt-8 font-suisse-intl text-body-lg text-primary-black sm:text-body-lg">
          {description}
        </p>
        {isProSubscriberNotBot && url && (
          <ProSecondaryButton buttonText={buttonText} clickText={buttonText} url={url} />
        )}
      </div>
      <LazyImgixImage
        alt={title}
        className="!flex w-full dark:bg-white dark:p-4"
        src={logoUrl}
        wrapperClassName="block sm:max-w-[465px] mt-16"
      />
    </div>
  );
};

export default ProPerk;
